module.exports = __webpack_public_path__ + "img/tab_icon3.7b8baf4a.png";